(function () {
  'use strict';

  const UpsellPopup = {
    isUpsellAdd: false,
    productData: null,

    init() {
      this.overlay = document.getElementById('cart-upsell-overlay');
      this.productNameEl = document.getElementById('upsell-product-name');
      this.productsGrid = document.getElementById('upsell-products-grid');
      this.productsSection = document.getElementById('upsell-products-section');
      this.closeBtn = document.getElementById('upsell-close-btn');

      if (!this.overlay) return;

      this.readProductData();
      this.bindEvents();
      this.interceptFetch();
    },

    readProductData() {
      const dataEl = document.getElementById('upsell-data');
      if (!dataEl) return;
      try {
        this.productData = JSON.parse(dataEl.textContent);
      } catch (e) {
        this.productData = null;
      }
    },

    bindEvents() {
      this.closeBtn.addEventListener('click', () => this.close());

      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    },

    interceptFetch() {
      const self = this;
      const originalFetch = window.fetch;

      window.fetch = function (...args) {
        const [resource] = args;
        const url = typeof resource === 'string' ? resource : resource?.url || '';

        if (url.includes('/cart/add') && !self.isUpsellAdd) {
          return originalFetch.apply(this, args).then((response) => {
            if (response.ok) {
              response
                .clone()
                .json()
                .then((data) => self.onItemAdded(data))
                .catch(() => {});
            }
            return response;
          });
        }

        return originalFetch.apply(this, args);
      };
    },

    onItemAdded(data) {
      const title = data.product_title || '';
      this.show(title);
    },

    async show(productTitle) {
      this.productNameEl.textContent = productTitle;
      this.productsSection.style.display = '';
      this.productsGrid.innerHTML = '<li class="upsell-popup__loading">Laden...</li>';

      this.overlay.classList.add('is-active');
      this.overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      const products = await this.fetchUpsellProducts();
      this.renderProducts(products);
    },

    close() {
      this.overlay.classList.remove('is-active');
      this.overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    async fetchUpsellProducts() {
      const upsellProducts = this.productData?.upsell_products;
      if (upsellProducts && upsellProducts.length > 0) {
        return this.fetchProductsByHandles(
          upsellProducts.slice(0, 3).map((p) => p.handle)
        );
      }

      const productId = this.productData?.current_product_id;
      if (productId) {
        return this.fetchRecommendations(productId);
      }

      return [];
    },

    async fetchProductsByHandles(handles) {
      const results = await Promise.allSettled(
        handles.map((handle) =>
          fetch(`/products/${handle}.js`).then((r) => (r.ok ? r.json() : null))
        )
      );
      return results
        .filter((r) => r.status === 'fulfilled' && r.value)
        .map((r) => r.value);
    },

    async fetchRecommendations(productId) {
      try {
        const res = await fetch(
          `/recommendations/products.json?product_id=${productId}&limit=3`
        );
        if (res.ok) {
          const data = await res.json();
          return data.products || [];
        }
      } catch (e) {}
      return [];
    },

    renderProducts(products) {
      if (!products.length) {
        this.productsSection.style.display = 'none';
        return;
      }

      this.productsGrid.innerHTML = products.map((p) => this.cardHTML(p)).join('');

      this.productsGrid.querySelectorAll('.js-bundle-quick-add').forEach((btn) => {
        btn.addEventListener('click', () => this.quickAdd(btn));
      });
    },

    cardHTML(product) {
      const variant = product.variants[0];
      const hasMultiple = product.variants.length > 1;
      const available = variant.available;

      const regularPrice = variant.compare_at_price || 0;
      const salePrice = variant.price;
      const isOnSale = regularPrice > salePrice;
      const salePercentage = isOnSale
        ? Math.round((1 - salePrice / regularPrice) * 100)
        : 0;

      const imageUrl = this.shopifyImageUrl(product.featured_image || product.images?.[0] || '', 150);

      const saleLabelHTML = isOnSale && salePercentage > 0
        ? `<span class="c-product-bundles__item--label c-product-bundles__item--label--discount">
             <span class="c-product-bundles__item--label--text">-${salePercentage}%</span>
           </span>`
        : '';

      const imageHTML = imageUrl
        ? `<img
             src="${imageUrl}"
             alt="Productafbeelding ${this.escapeHTML(product.title)}"
             class="c-product-bundles__item--image"
             width="300"
             loading="lazy"
           >`
        : '';

      const priceHTML = `
        <div class="c-product-bundles__price">
          <div class="c-price__inner">
            <div class="c-price ${isOnSale ? 'c-price--has-sale' : ''}">
              ${isOnSale ? `<s class="c-price__regular">${this.formatPrice(regularPrice)}</s>` : ''}
              <span class="c-price__sale">${this.formatPrice(salePrice)}</span>
            </div>
          </div>
        </div>
      `;

      const actionHTML = hasMultiple
        ? `<a href="/products/${product.handle}" class="c-product-bundles__item--options-link">Opties</a>`
        : `<button
             class="c-product-bundles__item--quick-add js-bundle-quick-add"
             data-variant-id="${variant.id}"
             aria-label="${this.escapeHTML(product.title)} toevoegen aan winkelwagen"
             ${!available ? 'disabled' : ''}
           >
             <svg class="icon icon-cart" xmlns="http://www.w3.org/2000/svg" width="17.501" height="15.784" viewBox="0 0 17.501 15.784">
               <g transform="translate(-1.589 -2.25)">
                 <path d="M16.612,6.75H4.066a.651.651,0,0,0-.414.149.583.583,0,0,0-.207.37l-1.1,9.364a.553.553,0,0,0,.025.243.578.578,0,0,0,.128.212.62.62,0,0,0,.208.145.652.652,0,0,0,.253.052H17.722a.651.651,0,0,0,.253-.052.62.62,0,0,0,.208-.145.576.576,0,0,0,.128-.212.553.553,0,0,0,.025-.243l-1.1-9.364a.583.583,0,0,0-.207-.37.651.651,0,0,0-.414-.149Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                 <path d="M8.25,6.75a3.75,3.75,0,1,1,7.5,0" transform="translate(-1.661)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
               </g>
             </svg>
             <div class="loading__spinner hidden">
               <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                 <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/>
               </svg>
             </div>
           </button>`;

      return `
        <li class="c-product-bundles__item">
          <a href="/products/${product.handle}" class="c-product-bundles__item--link">
            <div class="c-product-bundles__item--inner">
              <figure class="c-product-bundles__item--figure">
                ${saleLabelHTML}
                <div class="o-placeholder__product"></div>
                ${imageHTML}
              </figure>
              <div class="c-product-bundles__item--content">
                <div class="c-product-bundles__item--meta">
                  <strong class="c-product-bundles__item--title">${this.escapeHTML(product.title)}</strong>
                  ${priceHTML}
                </div>
              </div>
            </div>
          </a>
          ${actionHTML}
        </li>
      `;
    },

    async quickAdd(btn) {
      if (btn.disabled || btn.dataset.loading === 'true') return;

      const variantId = btn.dataset.variantId;
      const spinner = btn.querySelector('.loading__spinner');
      const icon = btn.querySelector('.icon-cart');

      btn.dataset.loading = 'true';
      spinner?.classList.remove('hidden');
      // if (icon) icon.style.display = 'none';

      this.isUpsellAdd = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        });

        if (res.ok) {
          spinner?.classList.add('hidden');
          // btn.classList.add('is-added');
          btn.disabled = true;
          
          this.updateCartCount();
        } else {
          this.resetQuickAddBtn(btn, spinner, icon);
        }
      } catch (e) {
        this.resetQuickAddBtn(btn, spinner, icon);
      } finally {
        btn.dataset.loading = 'false';
        this.isUpsellAdd = false;
      }
    },

    resetQuickAddBtn(btn, spinner, icon) {
      spinner?.classList.add('hidden');
      if (icon) icon.style.display = '';
      btn.dataset.loading = 'false';
    },

    async updateCartCount() {
      try {
        const res = await fetch('/cart.js');
        if (!res.ok) return;
        const cart = await res.json();
        const count = cart.item_count;

        document
          .querySelectorAll('.cart-count-bubble span:not([aria-hidden]), [data-cart-count]')
          .forEach((el) => { el.textContent = count; });

        const cartLink = document.querySelector('a[href="/cart"]');
        if (cartLink) {
          cartLink.setAttribute('aria-label', `Winkelwagen (${count} items)`);
        }
      } catch (e) {}
    },

    // Returns a Shopify CDN URL with the requested pixel width
    shopifyImageUrl(src, width) {
      if (!src) return '';
      const url = src.startsWith('//') ? `https:${src}` : src;
      const sep = url.includes('?') ? '&' : '?';
      return `${url}${sep}width=${width}`;
    },

    // Matches Shopify's money_without_currency in nl-NL (e.g. 29,95)
    formatPrice(cents) {
      return new Intl.NumberFormat('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    },

    escapeHTML(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => UpsellPopup.init());
  } else {
    UpsellPopup.init();
  }

  window.UpsellPopup = UpsellPopup;
})();
